import {
  type EntitlementAttributeColumnModel,
  type EntitlementAttributeMappingModel,
} from "@/api";
import { DEMO_DATASOURCE_IDS } from "@/api/mock-data/lakehouse/dataSources";

/**
 * Unified Lakehouse User Attributes tab — demo-only mock data. There is no
 * real backend endpoint for this yet (see `demoOnlyConfig` in
 * src/configs/mock.ts), so this stays mocked even after the rest of Unified
 * Lakehouse moved off mock mode.
 */
type UnifiedUserAttributeMapping = EntitlementAttributeMappingModel & {
  mappingStatus?: string;
  platform?: string;
};

type UnifiedUserAttribute = EntitlementAttributeColumnModel & {
  id: string;
  status: "Active" | "Inactive";
  mapping: UnifiedUserAttributeMapping[];
};

export const ulhEntitlementAttributes: UnifiedUserAttribute[] = [
  {
    id: "user_department",
    displayName: "user_department",
    name: "dept_id",
    type: "String",
    status: "Active",
    mapping: [
      {
        targetAccount: DEMO_DATASOURCE_IDS.dremio,
        platform: "dremio",
        name: "department_name",
        actualDataType: "String",
        mappingStatus: "Fully Mapped",
      },
      {
        targetAccount: DEMO_DATASOURCE_IDS.snowflake,
        platform: "snowflake",
        name: "dept_id",
        actualDataType: "String",
        mappingStatus: "Fully Mapped",
      },
      {
        targetAccount: DEMO_DATASOURCE_IDS.snowflake,
        platform: "snowflake",
        name: "dpt_num",
        actualDataType: "Integer",
        mappingStatus: "Type Mismatch",
      },
      {
        targetAccount: DEMO_DATASOURCE_IDS.dremio,
        platform: "dremio",
        name: "N/A",
        actualDataType: "N/A",
        mappingStatus: "Missing",
      },
    ],
  },
  {
    id: "user_clearance_level",
    displayName: "user_clearance_level",
    name: "clearance",
    type: "Integer",
    status: "Active",
    mapping: [
      {
        targetAccount: DEMO_DATASOURCE_IDS.dremio,
        platform: "dremio",
        name: "clearance",
        actualDataType: "Integer",
        mappingStatus: "Fully Mapped",
      },
      {
        targetAccount: DEMO_DATASOURCE_IDS.snowflake,
        platform: "snowflake",
        name: "clearance_level",
        actualDataType: "Integer",
        mappingStatus: "Fully Mapped",
      },
    ],
  },
  {
    id: "user_region",
    displayName: "user_region",
    name: "geo_region",
    type: "String",
    status: "Inactive",
    mapping: [
      {
        targetAccount: DEMO_DATASOURCE_IDS.dremio,
        platform: "dremio",
        name: "region",
        actualDataType: "String",
        mappingStatus: "Fully Mapped",
      },
      {
        targetAccount: DEMO_DATASOURCE_IDS.snowflake,
        platform: "snowflake",
        name: "N/A",
        actualDataType: "N/A",
        mappingStatus: "Missing",
      },
    ],
  },
  {
    id: "user_role_type",
    displayName: "user_role_type",
    name: "role_type",
    type: "String",
    status: "Active",
    mapping: [
      {
        targetAccount: DEMO_DATASOURCE_IDS.dremio,
        platform: "dremio",
        name: "role_type",
        actualDataType: "String",
        mappingStatus: "Fully Mapped",
      },
      {
        targetAccount: DEMO_DATASOURCE_IDS.snowflake,
        platform: "snowflake",
        name: "role_type",
        actualDataType: "String",
        mappingStatus: "Fully Mapped",
      },
    ],
  },
];

